import { CssType, ThemeType } from '../../../../../theming/jssTypes';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles(
  (theme: ThemeType): CssType => ({
    col: {
      padding: theme.spacing[1],
      marginLeft: theme.spacing[3],
    },
    selectStyle: {
      minWidth: '100%',
    },
    row: {
      padding: theme.spacing[2],
    },
    inputStyle: {
      width: '100%',
    },
  }),
);
export default useStyles;
